import { mods } from '@approvalmax/theme';
import { Flex } from '@approvalmax/ui/src/components';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { LineItemFooterLineProps } from './LineItemFooterLine.types';

export const Root = styled(Flex)<StyledMods<Pick<LineItemFooterLineProps, 'warning'>>>`
    ${mods('warning', true)`
        border-bottom: 5px solid #ffe688;
    `};
`;
